import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';

@Injectable()
export class InvoiceIssueLogService {

    constructor(private http: HttpClient) { }

    add = (data): Observable<any> => {
        return this.http.post<any>(`${environment.order}/InvoiceIssueLog`, data);
    }
}